import { ComponentIds, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
import { COMPONENT_DOESNT_EXIST, CONNECTOR_DOESNT_EXISTS, NO_HOST_CONNECTION_COMPONENT, NO_SIZE, } from "../constants/errors";
/**
 * Get connectors component
 * @param entity
 */
export const getConnectorsComponent = (entity) => {
    const connectors = entity.getComponent(ComponentIds.CONNECTORS_COMPONENT_ID);
    if (!connectors)
        throw new Error(CONNECTOR_DOESNT_EXISTS);
    return connectors;
};
/**
 * Gets host connection component
 * @param entity
 * @param allowUndefined
 */
export const getHostConnectionComponent = (entity, allowUndefined = false) => {
    const hostConnectionsComponent = entity.getComponent(ComponentIds.HOST_CONNECTIONS_COMPONENT_ID);
    if (!allowUndefined && !hostConnectionsComponent)
        throw new Error(NO_HOST_CONNECTION_COMPONENT);
    return hostConnectionsComponent;
};
/**
 * Gets host connection component
 * @param entity
 */
export const getHostConnections = (entity) => {
    return getHostConnectionComponent(entity).connections;
};
/**
 * Get Product ref
 * @param entity
 */
export const getProductRef = (entity) => { var _a; return (_a = getProductRefComponent(entity, true)) !== null && _a !== void 0 ? _a : ""; };
/**
 * Get product ref component
 * @param entity
 * @param allowFail
 */
export const getProductRefComponent = (entity, allowFail = false) => {
    var _a, _b;
    const productRefComponent = (_b = (_a = entity.getComponent(ComponentIds.PRODUCT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.productRef) !== null && _b !== void 0 ? _b : "";
    if (!productRefComponent && !allowFail)
        throw new Error(COMPONENT_DOESNT_EXIST);
    return productRefComponent;
};
/**
 * Get adjustable state component
 * @param entity
 * @param allowFail
 */
export const getAdjustableStateComponent = (entity, allowFail = false) => {
    const adjustableStateComponent = entity.getComponent(COMPONENT_IDS.ADJUSTABLE_STATE_COMPONENT);
    if (!adjustableStateComponent && !allowFail)
        throw new Error(COMPONENT_DOESNT_EXIST);
    return adjustableStateComponent;
};
/**
 * Get adjustableData component
 * @param entity
 * @param allowFail
 */
export const getAdjustableDataComponent = (entity, allowFail = false) => {
    const adjustableStateComponent = entity.getComponent(COMPONENT_IDS.ADJUSTABLE_COMPONENT);
    if (!adjustableStateComponent && !allowFail)
        throw new Error(COMPONENT_DOESNT_EXIST);
    return adjustableStateComponent;
};
/**
 * Get a list of all the connections an entity has
 * @param entity
 * @returns
 */
export const getGuestConnectionsComponent = (entity) => {
    const guestConnectionsComponent = entity.getComponent(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
    if (!guestConnectionsComponent)
        throw new Error(COMPONENT_DOESNT_EXIST);
    return guestConnectionsComponent;
};
/**
 * Get guest connections
 * @param entity
 */
export const getGuestConnections = (entity) => getGuestConnectionsComponent(entity).connections;
/**
 * Get template component
 * @param entity
 */
export const getTemplateDataComponent = (entity) => {
    const templateComponent = entity.getComponent(ComponentIds.TEMPLATE_DATA_COMPONENT_ID);
    if (!templateComponent)
        throw new Error(NO_SIZE);
    return templateComponent;
};
/**
 * Get viewer object component
 * @param entity
 */
export const getViewerObjectComponent = (entity) => {
    const viewerObjectComponent = entity.getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
    if (!viewerObjectComponent)
        throw new Error(COMPONENT_DOESNT_EXIST);
    return viewerObjectComponent;
};
/**
 * Get viewer object
 * @param entity
 */
export const getViewerObject = (entity) => getViewerObjectComponent(entity).viewerObject;
